<template>
    <div class="course-info-tab-container" :class="{'mobile-course-info-tab-container':isMobile}">
        <div class="course-info-tab-inner">
            <a-tabs defaultActiveKey="1" :tabBarStyle="{padding:'0 10px',margin:0,textAlign:'center'}">
                <a-tab-pane tab="课程描述" key="1">
                    <div class="course-bottom">
                        <div v-if="!isLoadCourse" v-html="courseInfo.courseDetail"></div>
                        <a-skeleton v-else active/>
                    </div>
                </a-tab-pane>

                <a-tab-pane tab="目录" key="2">
                    <div class="course-bottom">
                        <section-list :is-course-play="isCoursePlay"/>
                    </div>
                </a-tab-pane>

                <a-tab-pane tab="评论" key="3">
                    <div class="course-bottom">
                        <Comment :course-id="$route.params.courseId" :section-id="selectedSection.sectionId"
                                 :isCourse="false" :is-course-play="isCoursePlay"/>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
</template>

<script>
    import Comment from "@views/live-online/components/Comment";
    import SectionList from "@views/live-online/components/SectionList";
    import {createNamespacedHelpers} from "vuex";
    import common from "../../../mixin/common";
    // import {getLiveCourseDetail} from "@api/course-live-online"

    const {mapState} = createNamespacedHelpers('courseLiveOnline');


    export default {
        name: "CourseInfoTab",
        mixins: [common],
        components: {
            Comment,
            SectionList
        },
        props: {
            isCoursePlay: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                //未请求到数据
                // isLoadCourse:true,
                //    直播课程详情
                // courseInfo:{},
                // isCollect:false,
                // isInShoppingCart:false,
                // isPaid:false,
                // score:5,
                //    是否报名
                // isSignUp:false
            }
        },
        created() {
            // getLiveCourseDetail(this.$route.params.courseId).then((res)=>{
            //     console.log(res)
            //     if (res.code == 0){
            //         // this.isLoadCourse = false
            //         // this.courseInfo = res.data
            //         // this.isInShoppingCart = res.isInShoppingCart
            //         // this.isPaid  =  res.isPaid
            //         // this.score  =  res.score
            //         // this.isSignUp = res.isSignUp
            //     } else {
            //         console.error(res.msg)
            //     }
            //
            // })
            // console.log(this.selectedSection)
        },
        computed: {
            isFree() {
                return this.$func.isTrue(this.courseInfo.isFree)
            },
            isDiscount() {
                return this.$func.isTrue(this.courseInfo.isDiscount)
            },
            ...mapState({
                selectedSection: 'selectedSection',
                courseInfo: 'courseInfo',
                isLoadCourse: "isLoadCourse",
                score: 'score',
                isSignUp: "isSignUp"
            }),
        },
    }
</script>

<style scoped lang="less">
    .course-info-tab-container {
        width: 100%;
        background: white;
    }

    .course-info-tab-inner {
        padding: 0 10px;
    }

    .course-bottom {
        padding: 30px;
    }

    .course-detail {
        background: #F4F4F4;
    }

    // 移动端样式
    .mobile-course-info-tab-container {
        .course-bottom {
            padding: 10px;
        }

        .course-info-tab-inner {
            padding: 0;
        }

    }

    /deep/ .ant-tabs .ant-tabs-bottom-content > .ant-tabs-tabpane-inactive, .ant-tabs .ant-tabs-top-content > .ant-tabs-tabpane-inactive {
        height: 0;
        overflow: hidden;
        opacity: 1;
    }

</style>
